import { render, staticRenderFns } from "./AssistanteDashboard.vue?vue&type=template&id=3d7d1a10&scoped=true"
import script from "./AssistanteDashboard.vue?vue&type=script&lang=js"
export * from "./AssistanteDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7d1a10",
  null
  
)

export default component.exports